import {Component, Input, OnInit} from '@angular/core';
import {
  InsuranceCompanyTableOffers,
  OffersTableService
} from '../../../../../../core/services/impl/offers-table.service';

@Component({
  selector: 'app-offers-table-row',
  templateUrl: './offers-table-row.component.html',
  styleUrls: []
})
export class OffersTableRowComponent implements OnInit {

  @Input() data: InsuranceCompanyTableOffers;

  get expanded(): boolean {
    return this.offersTableService.isInsuranceCompanyExpanded(this.data.insuranceCompanyCode);
  }

  constructor(public offersTableService: OffersTableService) { }

  ngOnInit() {
  }

  toggleOffers(): void {
    const icCode = this.expanded ? null : this.data.insuranceCompanyCode;
    this.offersTableService.changeExpandedInsuranceCompany(icCode);
  }

}
